import React from "react";
import "./ToggleButton.scss";
import { Typography } from "@husqvarna/ui-core";

interface ToggleButtonOption {
  label: string;
  value: string;
}

interface ToggleButtonProps {
  options: ToggleButtonOption[];
  value: string;
  onChange: (value: string) => void;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className="toggle-button">
      {options.map((option) => {
        const selected = value === option.value;
        return (

            <button
              key={option.value}
              onClick={() => onChange(option.value)}
              className={`toggle-button__option${
                selected ? " toggle-button__option--selected" : ""
              }`}
              aria-pressed={selected}
            >
              <Typography tag="span" variant="Microcopy" className="toggle-button__option-text">
                {option.label}
              </Typography>
            </button>
        );
      })}
    </div>
  );
};

export default ToggleButton;
